import { createFileRoute } from "@tanstack/react-router";
import { fallback, zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

import { DocumentTitle } from "@/components";
import { SellerListPage, sellerListSortEnum } from "@/modules/user";
import { requireAuthAndPermission } from "@/utils";

const sellerListSearchSchema = z.object({
  q: fallback(z.string(), "").default(""),
  page: fallback(z.number(), 1).default(1),
  sort: fallback(sellerListSortEnum, "newest").default("newest")
});

export const Route = createFileRoute("/users/sellers/")({
  validateSearch: zodValidator(sellerListSearchSchema),
  beforeLoad: requireAuthAndPermission,
  component: () => (
    <>
      <DocumentTitle
        title="Sellers"
        description="View and manage seller accounts on the LAMPU Marketplace."
      />
      <SellerListPage />
    </>
  )
});

export type SellerListSearchSchema = z.infer<typeof sellerListSearchSchema>;
